package ru.notamedia.qah.managers

import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonElement

object PrettyFormatter {

    @OptIn(ExperimentalSerializationApi::class)
    private val prettyJson = Json {
        prettyPrint = true
        prettyPrintIndent = "  "
    }

    /** Пытается красиво отформатировать JSON-строку. Бросает исключение если строка не JSON. */
    private fun formatJsonPretty(input: String): String {
        val element: JsonElement = Json.parseToJsonElement(input)
        return prettyJson.encodeToString(JsonElement.serializer(), element)
    }

    /** Возвращает красиво отформатированный JSON или null, если парсинг не удался. */
    fun tryFormatJsonPretty(input: String): String? {
        return runCatching { formatJsonPretty(input) }.getOrNull()
    }
}
